import { render } from "preact";
import App from "./App";
import { getCurrentWidgetScript, readWidgetConfig } from "./lib/config";
import styles from "./styles/widget.css?inline";

const ROOT_ID = "qk-chatbot-root";

function mountWidget(): void {
  if (document.getElementById(ROOT_ID)) {
    return;
  }

  const widgetConfig = readWidgetConfig(getCurrentWidgetScript());

  if (!widgetConfig) {
    return;
  }

  const host = document.createElement("div");
  host.id = ROOT_ID;
  document.body.appendChild(host);

  const shadowRoot = host.attachShadow({ mode: "open" });
  const style = document.createElement("style");
  style.textContent = styles;
  const appRoot = document.createElement("div");
  appRoot.className = "qk-chatbot-shell";

  shadowRoot.append(style, appRoot);
  render(<App config={widgetConfig} />, appRoot);
}

if (document.readyState === "loading") {
  document.addEventListener("DOMContentLoaded", mountWidget, { once: true });
} else {
  mountWidget();
}
